import ContinueRegistration from './ContinueRegistration'

export { ContinueRegistration }
